import React, { FC } from 'react';
import { Observer } from 'mobx-react';
import { useTheme } from '@mui/material/styles';
import { Tab, Tabs, Typography } from '@mui/material';

import { Modal } from '@shared/components/Modal';
import { ThemeProps } from '@styles/theme';
import { useIntegrationsUIStore } from '@core/useStores';

import { IntegrationsTab } from 'Integrations/stores/IntegrationsUI.store';
import { messages } from 'Integrations/integrations.messages';
import { ExternalLmsTab, LtiTab } from './components';
import { useStyles } from './IntegrationsModal.styles';

type IntegrationsModalProps = {
    isOpen: boolean;
    onRequestClose: () => void;
};

export const IntegrationsModal: FC<IntegrationsModalProps> = ({ isOpen, onRequestClose }) => {
    const theme = useTheme<ThemeProps>();
    const styles = useStyles({ theme });

    const integrationsUIStore = useIntegrationsUIStore();

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            className={styles.modal}
            shouldCloseOnOverlayClick={false}
        >
            <div className={styles.header}>
                <Typography variant='h5' color='primary'>
                    {messages['integrations.modal.title']}
                </Typography>
                <Typography variant='body2' color='textSecondary'>
                    {messages['integrations.modal.subtitle']}
                </Typography>
            </div>

            <Observer>
                {() => (
                    <>
                        <Tabs
                            value={integrationsUIStore.activeTab}
                            onChange={(_event, tab: IntegrationsTab) => integrationsUIStore.setActiveTab(tab)}
                            indicatorColor='primary'
                            textColor='primary'
                            variant='scrollable'
                            scrollButtons={false}
                            className={styles.tabs}
                        >
                            <Tab value={IntegrationsTab.ExternalLms} label={messages['integrations.tabs.externalLms']} />
                            <Tab value={IntegrationsTab.Lti} label={messages['integrations.tabs.lti']} />
                        </Tabs>

                        {integrationsUIStore.activeTab === IntegrationsTab.ExternalLms && (
                            <ExternalLmsTab onRequestClose={onRequestClose} />
                        )}
                        {integrationsUIStore.activeTab === IntegrationsTab.Lti && (
                            <LtiTab onRequestClose={onRequestClose} />
                        )}
                    </>
                )}
            </Observer>
        </Modal>
    );
};
